<template>
  <div class="w-full min-h-[298px]">
    <div class="poster-box" ref="posterBox" :style="posterWrapperStyle">
      <div class="poster__inner">
        <div class="poster__inner__head">
          <img class="poster__head" :src="data.productImg" />
          <div class="poster__name">{{ data.productName }}</div>
          <div class="poster__price">
            <span class="poster__price__union">￥</span>
            <span class="poster__price__num">{{ data.min_price }}</span>
            <span class="poster__price__text">起</span>
          </div>
        </div>
        <div class="poster__split">
          <img src="@/assets/img/product/poster_split.png" />
        </div>
        <div class="poster__inner__footer">
          <div class="poster__info">
            <template v-if="isOpenShop">
              <img class="poster__avatar" :src="data.shop_head_url" />
              <div>
                <div class="poster__shop__name">{{ data.shop_name }}</div>
                <div class="poster__shop__desc">长按查看商品详情</div>
              </div>
            </template>
            <div v-else class="text-left text-base" >朋友给您推荐了优质产品<br>长按识别看看吧</div>
            <img class="poster__code" :src="data.qrcode_url" />
          </div>
        </div>
      </div>
    </div>
    <div class="w-[178px] min-h-[298px]" :style="posterWrapperStyle">
      <img :src="posterUrl" class="w-full" />
    </div>
  </div>
</template>
<script>
import html2canvas from "html2canvas";
import analyze from "rgbaster";
import { downloadByBlob } from "@/utils/file-download";
import { computed, defineComponent, useContext } from "@nuxtjs/composition-api";

export default defineComponent({
  props: {
    data: {
      type: Object,
      default: () => ({
        productName: "",
        productImg: "",
        productPosterBg: "",
        min_price: "",
        shop_name: "",
        shop_head_url: "",
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const {
      store
    } = useContext();
    const isOpenShop = computed(() => store.getters.isOpenShop);
    return {
      isOpenShop
    }
  },
  data() {
    return {
      posterWrapperStyle: "",
      posterUrl:""
    };
  },
  async mounted() {
    const analyzeData = await analyze(this.data.productPosterBg, {
      ignore: ["rgb(255,255,255)", "rgb(0,0,0)"],
      scale: 0.6,
    });
    this.posterWrapperStyle = { backgroundColor: analyzeData[0].color };
    this.$nextTick(() => {
      this.$emit("update:loading", false);
      this.createImage();
    });
  },
  methods: {
    // download() {
    //   if (this.$refs.posterBox) {
    //     return html2canvas(this.$refs.posterBox, {
    //       width: this.$refs.posterBox.getBoundingClientRect().width,
    //       height: this.$refs.posterBox.getBoundingClientRect().height,
    //       scale: 3,
    //       // canvas: "",
    //       allowTaint: true,
    //       useCORS: true,
    //     })
    //       .then((canvas) => {
    //         const posterUrl = canvas.toDataURL("image/jpeg", 1);
    //         downloadByBlob(posterUrl, '产品海报');
    //       })
    //       .catch((err) => {
    //         console.error(err);
    //         // Toast.clear();
    //       });
    //   }
    // },
    createImage(){
      let that = this;
      if (this.$refs.posterBox) {
        return html2canvas(this.$refs.posterBox, {
          width: this.$refs.posterBox.getBoundingClientRect().width,
          height: this.$refs.posterBox.getBoundingClientRect().height,
          scale: 3,
          // canvas: "",
          allowTaint: true,
          useCORS: true,
        }) .then((canvas) => {
          that.posterUrl = canvas.toDataURL("image/jpeg", 1);
        })
      }
    },
    download() {
      downloadByBlob(this.posterUrl, '产品海报');
    }
  },
});
</script>
<style lang="scss" scoped>

.tip {
  text-align: center;
  font-size: 14px;
  color: #333;
}
.posterImg {
  width: 494px;
  user-select: none;
  -webkit-user-select: none;
}

.poster-box {
  width: 442px;
  position: absolute;
  background: #fff;
  padding: 36px 26px;
  margin-left: -999em; //让html结构不在屏幕内显示
  .goods-info {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .code {
      width: 1.4rem;
      height: 1.4rem;
      line-height: 1.4rem;
      text-align: center;
      color: #fff;
      background: #ddd;
      margin-left: 0.1rem;
    }
    .title-box {
      width: 0;
      flex: 1;
    }
    .title {
      text-align: justify;
      font-size: 0.3rem;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .price {
      color: red;
      font-size: 16px;
      font-weight: bold;
      margin-top: 15px;
    }
  }
}
.poster {
  width: 5.5rem;
}
.blurImg {
  width: 440px;
  height: 334px;
}
.poster {
  &__inner {
    position: relative;
    &__head {
      background-color: #fff;
    }
    &__footer {
      background-color: #fff;
      padding-bottom: 38px;
      padding-top: 10px;
    }
  }
  &__head {
    width: 100%;
    height: 365px;
    object-fit: cover;
  }
  &__name {
    font-size: 22px;
    background-color: #fff;
    padding: 18px 18px 8px;
    color: #333;
  }
  &__price {
    padding: 0 18px 10px;
    &__union {
      color: $color-orange;
      font-size: 21px;
    }
    &__num {
      color: $color-orange;
      font-size: 37px;
      font-weight: bold;
    }
    &__text {
      color: #666;
      font-size: 21px;
    }
  }
  &__info {
    display: flex;
    padding: 0 18px;
    align-items: center;
  }
  &__avatar {
    width: 65px;
    height: 65px;
    border-radius: 56px;
    margin-right: 14px;
  }
  &__shop__name {
    color: #333;
    font-size: 16px;
  }
  &__shop__desc {
    color: #666;
    font-size: 16px;
  }
  &__code {
    width: 82px;
    height: 82px;
    position: absolute;
    right: 18px;
  }
  &__split {
    display: flex;
    min-height: 36px;
    height: 36px;
    font-size: 0;
    line-height: 0;
    margin-top: -2px;
    margin-bottom: -2px;
    img {
      display: block;
      width: 100%;
      height: 36px;
    }
  }
}
.poster__bg {
  &--blur {
    filter: blur(2px);
  }
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

</style>